module.exports = __webpack_public_path__ + "static/media/health1.f7021dab.jpeg";